var React = require('react');

function AssetRealEstate (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"fill":"#333647","d":"M8.77884615 18H3.30528846V9.5204513H0L11 0l11 9.5204513h-3.3052885V18h-5.4735577v-6.3469676H8.77884615z","key":0}),React.createElement("path",{"d":"M-1-3h24v24H-1z","key":1})]));
}

AssetRealEstate.defaultProps = {"viewBox":"0 0 22 18"};

module.exports = AssetRealEstate;

AssetRealEstate.default = AssetRealEstate;
